import { Bank } from "app/models/bank";

import request from "../request";
import { GenericResponse } from "../types";
import { VerifyBankDetailsParams, VerifyBankDetailsResponse } from "./types";
import { PLATFORM_URL } from "app/constants/variables";

const options = {
  baseURL: PLATFORM_URL,
};

export const getBanks = () => {
  return request.get<GenericResponse<Bank[]>>(`/banks`, {
    ...options,
  });
};

export const verifyBankDetails = (data: VerifyBankDetailsParams) => {
  return request.post<VerifyBankDetailsResponse>(
    `/recipients/resolve-bank-account`,
    data,
    { ...options }
  );
};
